import OrgsService from '../../../services/orgs';
import { updateStripeConnectAccount } from '../../../services/vault/stripeConnectAccount';
import { createShortLivedToken } from '../../../services/vault/token';
import { logVgsFormSubmitResponse } from '../../../util/logger';

import { requestBodyFormatter } from './requestBodyFormatter';
import { StripeEnv } from '../../../util/enums';

export type KybData = {
  kybId: string;
  provider: VaultProvider;
};

export type UpdateKybProps = {
  stripeEnv?: StripeEnv;
  kybId: string;
  onSuccess?: (successData: KybData[]) => void;
};

export type SubmitProps = {
  provider: VaultProvider;
  form: VGSForm<{ vaultKybUpdate: string }>;
};

const submit =
  ({ stripeEnv, kybId, onSuccess }: UpdateKybProps) =>
  async ({ form, provider }: SubmitProps): Promise<void> => {
    const token = await createShortLivedToken();

    return new Promise((resolve, reject) => {
      form.submit(
        '/graphql',
        {
          data: requestBodyFormatter({
            kybId,
          }),
          headers: {
            Authorization: `Bearer ${token}`,
          },
          withCredentials: true,
        },
        async (responseStatus, { data, errors }) => {
          logVgsFormSubmitResponse({
            formName: 'UpdateKyb',
            responseStatus,
            data,
            errors,
          });
          if (responseStatus !== 200) {
            throw new Error(`Received ${responseStatus} status.`);
          }

          const financialAcctOrgs =
            await OrgsService.getFinancialAcctOrgByKybId(kybId);
          const filteredFinancialAcctOrgs = financialAcctOrgs.filter(
            (fao) => fao.processor === provider.toUpperCase(),
          );
          try {
            await Promise.all(
              filteredFinancialAcctOrgs.map((fao) => {
                if (fao.acctId) {
                  updateStripeConnectAccount(fao.acctId, kybId, stripeEnv);
                }
              }),
            );
            if (onSuccess !== undefined) {
              onSuccess(
                filteredFinancialAcctOrgs.map((fao) => ({
                  kybId,
                  acctId: fao.acctId,
                  provider,
                })),
              );
            }
            resolve();
          } catch (e) {
            reject(e);
          }
        },
        (errors) => {
          reject(errors);
        },
      );
    });
  };

export default submit;
